import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import useTokenVerification from "../hooks/useTokenVerification";
import "bootstrap/dist/css/bootstrap.min.css";
import { EnvelopeFill } from "react-bootstrap-icons";
import { FaGooglePlay, FaSignInAlt, FaDesktop } from "react-icons/fa";

const VerificationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Call the token verification hook
  const { isLoading, isData, isError, verifyToken } = useTokenVerification();

  useEffect(() => {
    // Extract token from URL
    const token = searchParams.get("token");
    if (token) {
      verifyToken(token);
    }
  }, [searchParams]);

  console.log("err: ", isError);
  console.log("data: ", isData);

  const hasDataObject =
    isData && typeof isData === "object" && !React.isValidElement(isData);

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100 px-3"
      style={{ backgroundColor: "#043476" }}
    >
      <div
        className="card text-center shadow-lg p-4 p-md-5"
        style={{
          maxWidth: "600px",
          width: "100%",
          borderRadius: "15px",
          backgroundColor: "white",
        }}
      >
        {/* Email Icon Inside Blue Circle */}
        <div className="d-flex justify-content-center">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "#18beca",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
            }}
          >
            <EnvelopeFill size={45} color="white" />
          </div>
        </div>

        <h3 className="mt-4" style={{ color: "#043476" }}>
          Verify your email!
        </h3>
        {!hasDataObject && !isError && (
          <div className="text-center p-4 bg-light rounded-3">
            <p className="text-muted mb-4 px-2 fs-5">
              Welcome! Before getting started, we need to verify your email
              address. Please check your inbox for our verification link to
              complete the process.
            </p>
          </div>
        )}

        {/* Loading State */}
        {isLoading && (
          <div className="d-flex flex-column align-items-center">
            <div
              className="spinner-grow text-primary"
              style={{ width: "12px", height: "12px" }}
            ></div>
            <p className="mt-3 text-primary">Awaiting verification</p>
          </div>
        )}

        {/* Error State */}
        {/* {isError && !isData && (
          <div
            className="alert alert-danger d-flex flex-column align-items-center p-3 mt-3"
            style={{
              backgroundColor: "#f8d7da",
              border: "1px solid #dc3545",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <div className="d-flex align-items-center">
              <strong className="fs-4 fw-bold">Error:</strong>{" "}
              <span className="fs-4 fw-semibold ps-3">
                {typeof isError === "object"
                  ? isError.message || "Verification failed."
                  : isError}
              </span>
            </div>
          </div>
        )} */}

        {/* Success State */}
        {(hasDataObject || isError === "Member already exists.") && (
            <>
              <div className="text-center p-4 bg-light rounded-3">
                <p className="text-muted mb-1 px-2 fs-5">
                  Welcome! Continue your journey by installing our Android
                  application.
                </p>
              </div>

              {/* <div className="text-center p-4 bg-light rounded-3">
                <p className="text-muted mb-4 px-2 fs-5">
                  Login in to your dasboard by clicking{" "}
                  <a target="_blank" href="https://app.v2vbn.org/login">
                    here
                  </a>
                  .
                </p>
              </div> */}

              <div className="text-center mb-4">
                <div className="mb-3" style={{ color: "#34a853" }}>
                  <svg viewBox="0 0 24 24" width="48" height="48">
                    <path
                      fill="currentColor"
                      d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                    />
                  </svg>
                </div>
                <p className="fs-4 fw-semibold">
                  Email verification completed successfully.
                </p>
                <button
                  onClick={() =>
                    (window.location.href = "https://app.v2vbn.org/login")
                  }
                  className="btn btn-primary btn-lg"
                >
                  Login to your dashboard.
                </button>
              </div>

              <div className="d-flex justify-content-center gap-3">
                {/* <button
                  className="btn btn-light d-flex align-items-center gap-2 px-4 py-3"
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    minWidth: "200px",
                  }}
                  onClick={() =>
                    window.open("https://play.google.com/", "_blank")
                  }
                >
                  <FaGooglePlay size={24} style={{ color: "#666666" }} />
                  <span style={{ color: "#333333", fontSize: "1.1rem" }}>
                    Google Play
                  </span>
                </button> */}

                {/* <button
                className="btn btn-light d-flex align-items-center gap-2 px-4 py-3"
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  minWidth: "200px",
                }}
                onClick={() =>
                  window.open("https://app.v2vbn.org/login", "_blank")
                }
              >
                <FaDesktop size={24} style={{ color: "#666666" }} />
                <span style={{ color: "#333333", fontSize: "1.1rem" }}>
                  Login Dashboard
                </span>
              </button> */}
              </div>
            </>
          )}

        {/* Error State */}
        {isError && !hasDataObject && isError !== "Member already exists." && (
          <div
            className="alert d-flex flex-column align-items-center p-4 mt-3 rounded-3"
            style={{
              backgroundColor: "#fff8f8",
              border: "1px solid #ffcdd2",
              borderRadius: "12px",
              width: "100%",
            }}
          >
            <div className="mb-3" style={{ color: "#d32f2f" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
              </svg>
            </div>
            <div className="text-center">
              <h4 className="mb-2" style={{ color: "#d32f2f" }}>
                {isError ? isError : "Verification Failed"}
              </h4>
              <p className="fs-5 mb-0" style={{ color: "#616161" }}>
                {isError === "Member already exists." ? (
                  <>
                    You can login to your dashboard by clicking{" "}
                    <a
                      className="btn btn-link fw-bold p-0 text-primary text-decoration-none ms-1"
                      style={{ fontSize: "inherit" }}
                      target="_blank"
                      href="https://app.v2vbn.org/login"
                    >
                      login here
                    </a>
                  </>
                ) : typeof isError === "object" ? (
                  isError.message
                ) : (
                  isError
                )}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificationPage;
